// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2QbNp","text":"SelectPayment_text__3gfwu","title":"SelectPayment_title__2D72C","btn":"SelectPayment_btn__1ij4p"};